import Typography from '@mui/material/Typography';

import Markdown from '@/modules/component/Markdown';
import Page from '@/modules/component/Page';
import PageMeta from '@/modules/component/PageMeta';
import { asLanguage, type Language } from '@/modules/i18n/languages';
import { registerLocaleResources, useTranslation } from '@/modules/i18n/useTranslation';

import en from './locales/en.json';
import contentEn from './locales/en.md?raw';
import es from './locales/es.json';
import contentEs from './locales/es.md?raw';
import ru from './locales/ru.json';
import contentRu from './locales/ru.md?raw';

registerLocaleResources('AboutMePage', { en, es, ru });

declare module '@/modules/i18n/namespaces' {
    interface LocaleNamespaces {
        AboutMePage: typeof en;
    }
}

const CONTENT: Readonly<Record<Language, string>> = { en: contentEn, es: contentEs, ru: contentRu };

const AboutMePage = () => {
    const { t, i18n } = useTranslation('AboutMePage');
    return (
        <Page>
            <PageMeta title={t('title')}/>
            <Typography component="div" align="left">
                {/* i18next's language, as for the title: both switch together once LanguageGate syncs it */}
                <Markdown>{CONTENT[asLanguage(i18n.resolvedLanguage)]}</Markdown>
            </Typography>
        </Page>
    );
};

export default AboutMePage;
